"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
const react_1 = __importStar(require("react"));
const styles_1 = require("@material-ui/core/styles");
const AccordionSummary_1 = __importDefault(require("@material-ui/core/AccordionSummary"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const ExpandLess_1 = __importDefault(require("@material-ui/icons/ExpandLess"));
const ExpandMore_1 = __importDefault(require("@material-ui/icons/ExpandMore"));
const clsx_1 = __importDefault(require("clsx"));
const Box_1 = __importDefault(require("../../../../layouts/Box"));
const useStyles = styles_1.makeStyles((theme) => ({
    root: {
        '&:hover': {
            color: theme.palette.grey[900],
        },
    },
    rootContainer: {
        backgroundColor: theme.palette.grey[100],
        color: theme.palette.grey[900],
        '& .MuiAccordionSummary-content': {
            padding: '10px 16px',
            margin: 0,
        },
    },
    header: {
        fontSize: '14px',
    },
    headerContainer: {
        fontWeight: 700,
    },
}));
const ExpansionPanelSummary = (_a) => {
    var { variant, expanded, header, description } = _a, props = __rest(_a, ["variant", "expanded", "header", "description"]);
    const styles = useStyles();
    const isContainer = variant === 'container';
    return (react_1.default.createElement(AccordionSummary_1.default, Object.assign({}, props, { className: clsx_1.default({
            [styles.rootContainer]: isContainer,
            [styles.root]: !isContainer,
        }) }),
        react_1.default.createElement(Box_1.default, { width: "100%" },
            react_1.default.createElement(Box_1.default, { display: "flex", alignItems: "center" },
                expanded ? react_1.default.createElement(ExpandLess_1.default, { transform: "rotate(180)" }) : react_1.default.createElement(ExpandMore_1.default, { transform: "rotate(-90)" }),
                typeof header === 'string' ? (react_1.default.createElement(Typography_1.default, { className: clsx_1.default({ [styles.header]: !isContainer }, { [styles.headerContainer]: isContainer }), variant: "h3" }, header)) : (header)),
            react_1.default.createElement(Box_1.default, { pl: 2.4 }, description && typeof description === 'string' ? (react_1.default.createElement(Typography_1.default, { variant: "body2", component: "span" }, description)) : (description)))));
};
exports.default = react_1.memo(ExpansionPanelSummary);
